module.exports = __webpack_public_path__ + "static/media/slider5.edded929.jpg";